import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

import { TOP_BAR_ICON_STROKE_WIDTH } from './topBarIconClasses';

interface TopBarSearchProps {
  onClick: () => void;
}

export const TopBarSearch: FC<TopBarSearchProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="flex h-10 w-full cursor-pointer items-center gap-2 rounded-full border border-community-text-on-bg/50 px-2.5 py-2 text-left transition-colors hover:bg-community-text-on-bg/10"
      aria-label={t('community.sidebar.search_placeholder')}
      onClick={onClick}
    >
      <MagnifyingGlassIcon
        className="size-5 shrink-0 text-community-text-on-bg/80"
        strokeWidth={TOP_BAR_ICON_STROKE_WIDTH}
      />
      <span className="text-[13px] font-medium tracking-[-0.13px] text-community-text-on-bg/80">
        {t('community.sidebar.search_placeholder')}
      </span>
    </button>
  );
};
